import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/shared/hooks/useAuth';
import { Spinner } from '@/shared/ui';

import styles from './guards.module.css';

function Waiting(): React.ReactElement {
  return (
    <div className={styles.waiting}>
      <Spinner size={28} />
    </div>
  );
}

/**
 * Проверяет что пользователь принял предупреждение о рисках.
 * Если нет - редиректит на экран принятия рисков.
 */
export function RiskGate({ children }: { children: ReactNode }): React.ReactElement {
  const { status, me } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <Waiting />;

  // Если не авторизован - пропускаем, RequireAuth сработает выше
  if (status === 'anon' || !me) {
    return <>{children}</>;
  }

  // Если риски только что приняли (флаг из navigate state) - пропускаем
  const risksJustAccepted = (location.state as { risksJustAccepted?: boolean } | null)
    ?.risksJustAccepted;
  if (risksJustAccepted) {
    return <>{children}</>;
  }

  // Если риски не приняты - редиректим на экран принятия
  if (!me.risk_accepted_at) {
    return <Navigate to="/risk-acceptance" replace />;
  }

  return <>{children}</>;
}
